export type AvailableFeatureAction = keyof typeof AvailableFeatureAction;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvailableFeatureAction = {
  ADDRESS_BOOK: 'ADDRESS_BOOK',
  API: 'API',
  ATTACHMENT_REQUEST: 'ATTACHMENT_REQUEST',
  BULK_REQUESTS: 'BULK_REQUESTS',
  CONTRACT_LINK: 'CONTRACT_LINK',
  CUSTOM_BRANDING_EMAIL: 'CUSTOM_BRANDING_EMAIL',
  CUSTOM_BRANDING_KAKAO_CHANNEL: 'CUSTOM_BRANDING_KAKAO_CHANNEL',
  DOCUMENTS: 'DOCUMENTS',
  EDITING_DOCUMENT: 'EDITING_DOCUMENT',
  EXPORT_INPUT_VALUES: 'EXPORT_INPUT_VALUES',
  EXTERNAL_DOCUMENT: 'EXTERNAL_DOCUMENT',
  IN_PERSON_CONTRACT: 'IN_PERSON_CONTRACT',
  TEMPLATES: 'TEMPLATES',
  WEBHOOK: 'WEBHOOK',
  WORKSPACE_SEAT: 'WORKSPACE_SEAT',
} as const;

export const availableFeatureActions = [
  AvailableFeatureAction.API,
  AvailableFeatureAction.ATTACHMENT_REQUEST,
  AvailableFeatureAction.BULK_REQUESTS,
  AvailableFeatureAction.CUSTOM_BRANDING_EMAIL,
  AvailableFeatureAction.CUSTOM_BRANDING_KAKAO_CHANNEL,
  AvailableFeatureAction.DOCUMENTS,
  AvailableFeatureAction.EDITING_DOCUMENT,
  AvailableFeatureAction.WORKSPACE_SEAT,
  AvailableFeatureAction.TEMPLATES,
  AvailableFeatureAction.WEBHOOK,
];

export default AvailableFeatureAction;
